(() => {
  const placeholderUrl = document.currentScript?.dataset.placeholderUrl;
  if (!placeholderUrl) return;

  const legacyPlaceholder = /photo(?:-|_)?coming(?:-|_)?soon|photocomingsoon/i;
  const genuineSquarePngs = /AmaryllisBelladonaMix_sm1\.png|juniper_allgold2\.png/i;
  const visuallyChecked = new WeakSet();

  const hasLegacyDimensions = (image) => {
    const source = image.currentSrc || image.src || '';
    if (!/\.png(?:\?|$)/i.test(source) || genuineSquarePngs.test(source)) return false;
    return (
      (image.naturalWidth === 1024 && image.naturalHeight === 1024) ||
      (image.naturalWidth === 1028 && image.naturalHeight === 1028) ||
      (image.naturalWidth === 1586 && image.naturalHeight === 1586)
    );
  };

  const applyPlaceholder = (image) => {
    image.removeAttribute('srcset');
    image.src = placeholderUrl;
    image.alt = '';
    image.classList.add('dancing-oaks-placeholder');
    image.closest('.product-card__image-wrapper')?.classList.add('has-dancing-oaks-placeholder');
  };

  const checkOmegaImage = async (image) => {
    if (visuallyChecked.has(image)) return;
    visuallyChecked.add(image);

    const source = image.currentSrc || image.src || '';
    if (
      !image.closest('.os-index-products') ||
      image.naturalWidth !== image.naturalHeight ||
      !/\.png(?:\?|$)/i.test(source)
    ) return;

    try {
      const sampleUrl = new URL(source, window.location.href);
      sampleUrl.host = window.location.host;
      sampleUrl.pathname = `/cdn/shop/${sampleUrl.pathname
        .replace(/^\/s\/files\/1\/1518\/9342\//, '')
        .replace(/_\d+x\d+(?=\.png$)/i, '_24x24')}`;

      const response = await fetch(sampleUrl, { credentials: 'same-origin' });
      if (!response.ok) return;
      const bitmap = await createImageBitmap(await response.blob());
      const canvas = document.createElement('canvas');
      canvas.width = 24;
      canvas.height = 24;
      const context = canvas.getContext('2d', { willReadFrequently: true });
      context.drawImage(bitmap, 0, 0, 24, 24);
      bitmap.close();

      const pixels = context.getImageData(0, 0, 24, 24).data;
      let luminance = 0;
      let luminanceSquared = 0;
      let saturation = 0;
      const pixelCount = 24 * 24;

      for (let index = 0; index < pixels.length; index += 4) {
        const red = pixels[index];
        const green = pixels[index + 1];
        const blue = pixels[index + 2];
        const value = 0.2126 * red + 0.7152 * green + 0.0722 * blue;
        luminance += value;
        luminanceSquared += value * value;
        saturation += Math.max(red, green, blue) - Math.min(red, green, blue);
      }

      const mean = luminance / pixelCount;
      const deviation = Math.sqrt(luminanceSquared / pixelCount - mean * mean);
      if (mean > 195 && mean < 220 && deviation < 5 && saturation / pixelCount < 8) {
        applyPlaceholder(image);
      }
    } catch (_error) {
      // If a CDN image cannot be sampled, leave the real product image intact.
    }
  };

  const updateImage = (image) => {
    const source = image.currentSrc || image.src || '';
    if (legacyPlaceholder.test(source) || hasLegacyDimensions(image)) {
      applyPlaceholder(image);
      return;
    }
    if (!image.complete) {
      image.addEventListener('load', () => updateImage(image), { once: true });
      return;
    }
    checkOmegaImage(image);
  };

  const updateImages = (root) => {
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    if (root.matches?.('img')) updateImage(root);
    root.querySelectorAll?.('img').forEach(updateImage);
  };

  updateImages(document.body);
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach(updateImages));
  }).observe(document.body, { childList: true, subtree: true });
})();
